
export const IMPORT_FILE_BEGIN = 'IMPORT_FILE_BEGIN'
export const IMPORT_FILE_SUCCESS = 'IMPORT_FILE_SUCCESS'
export const IMPORT_FILE_ERROR = 'IMPORT_FILE_ERROR'

export const IMPORT_SIMPLE_FILE_BEGIN = 'IMPORT_SIMPLE_FILE_BEGIN'
export const IMPORT_SIMPLE_FILE_SUCCESS = 'IMPORT_SIMPLE_FILE_SUCCESS'
export const IMPORT_SIMPLE_FILE_ERROR = 'IMPORT_SIMPLE_FILE_ERROR'

export const CLEAR_NEW_IMPORT_STATE = 'CLEAR_NEW_IMPORT_STATE'
